import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_project_RowClass, bl_fi_mst_segment_RowClass} from '../../dbschema';

export class ProjectCoaContainerModel extends BaseContainerModel {
  bl_fi_mst_project: bl_fi_mst_project_RowClass = new bl_fi_mst_project_RowClass();
}
